import BottomNavMenu from './BottomNavMenu';

export default BottomNavMenu;
